import type { LinkedIssue } from "../lib/issueLink"
import {Link2, X, ExternalLink} from 'lucide-react'

interface LinkedIssueBadgesProps {
  issues: LinkedIssue[]
  // 작성 화면에서 칩 제거용 (있으면 X 버튼 노출)
  onRemove?: (issueId: string) => void
  // 검토/조회 화면에서 클릭 시 딥링크 이동 (있으면 클릭 가능)
  onNavigate?: (issue: LinkedIssue) => void
}

export function LinkedIssueBadges({ issues, onRemove, onNavigate }: LinkedIssueBadgesProps) {
  if (!issues || issues.length === 0) return null

  return (
    <div className="flex flex-wrap gap-2">
      {issues.map((issue) => {
        const label = issue.issueTitle?.trim() || "제목없음"
        const clickable = !!onNavigate
        return (
          <span
            key={issue.issueId}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm border transition-colors ${
              clickable
                ? "bg-orange-50 border-orange-200 text-orange-700 hover:bg-orange-100 cursor-pointer"
                : "bg-gray-50 border-gray-200 text-gray-700"
            }`}
            onClick={clickable ? () => onNavigate!(issue) : undefined}
            title={`${issue.equipmentName ?? ""}${issue.unitLabel ? ` · ${issue.unitLabel}` : ""}`}
          >
            <Link2 className="w-3.5 h-3.5 shrink-0" />
            <span className="max-w-[220px] truncate">
              {issue.equipmentName ? `${issue.equipmentName} · ` : ""}
              {label}
            </span>
            {clickable && <ExternalLink className="w-3.5 h-3.5 shrink-0" />}
            {onRemove && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation()
                  onRemove(issue.issueId)
                }}
                className="ml-0.5 p-0.5 rounded-full hover:bg-black/10"
                aria-label="연결 해제"
              >
                <X className="w-3.5 h-3.5" />
              </button>
            )}
          </span>
        )
      })}
    </div>
  )
}
